import { decryptString, deriveKey } from "@/lib/crypto/crypto";
import {
  getEncryptedPassword,
  userExists,
} from "@/server/services/userService";
import { t } from "i18next";

export const checkUsernameExists = async (
  username: string,
): Promise<boolean> => {
  if (!username) {
    throw new Error(t("forgot.usernameNotProvided"));
  }

  return await userExists(username);
};
export const getEncryptedPasswordForUser = async (
  username: string,
): Promise<string> => {
  if (!username) {
    throw new Error(t("forgot.usernameNotProvided"));
  }
  const passwordData = await getEncryptedPassword(username);
  if (!passwordData.encryptedPassword) {
    throw new Error(t("forgot.noRecoveryPhraseSetUp"));
  }
  return passwordData.encryptedPassword;
};

export const decryptPasswordWithRecoveryKey = async (
  username: string,
  recoveryKey: string,
  encryptedPassword: string,
): Promise<string> => {
  if (!username) {
    throw new Error(t("forgot.usernameNotProvided"));
  }

  if (!recoveryKey) {
    throw new Error(t("forgot.recoveryKeyNotProvided"));
  }

  if (!encryptedPassword) {
    throw new Error(t("forgot.noRecoveryPhraseSetUp"));
  }

  const derivedKey = deriveKey(recoveryKey, username);

  const password = await decryptString(encryptedPassword, derivedKey);

  return password;
};
